import { JellyIcon } from '@/icons';
import { useUser } from '@/lib/auth';
import { Button } from '@/ui_v3';
import { useMyPoints } from '../hooks/useMyPoints';

/**
 * 아바타 꾸미기 상단 우측의 보유 포인트 칩(학생만). **표시 전용**이다.
 *
 * 데스크탑은 우측 프리뷰 패널, 모바일은 헤더 아래 컨트롤 행에 놓인다.
 * 두 레이아웃이 같은 칩을 써야 해서 컴포넌트로 분리했다.
 * (모바일은 AvatarPreviewPanel 자체를 렌더하지 않아 인라인으로 두면 한쪽에만 남는다)
 *
 * Tailwind preflight 가 `button` 에 `cursor: pointer` 를 깔기 때문에, 누를 수 없는데도
 * 손가락 커서가 떠서 "눌러야 될 것 같은데 아무 동작도 안 됨" 제보가 나왔다.
 * pointer-events-none 으로 호버 자체를 없애고 tabIndex=-1 로 탭 순서에서도 뺀다.
 * (같은 모양의 /profile/edit 칩은 '내 포인트' 로 가는 링크라 반대로 눌리게 두었다.)
 */
export const MyPointsChip = () => {
  const {
    user
  } = useUser();
  const {
    data: myPoints
  } = useMyPoints();
  if (user?.type?.toLowerCase() !== 'student') return null;
  return <Button variant="outlined" intent="neutral" size="md" rounded="full" tabIndex={-1} className="pointer-events-none bg-white shadow-[0px_1px_4px_0px_rgba(28,27,31,0.12),0px_0px_6px_0px_rgba(28,27,31,0.04)]" leftSlot={<JellyIcon size="sm" />} data-sentry-element="Button" data-sentry-component="MyPointsChip" data-sentry-source-file="MyPointsChip.tsx">
      {myPoints?.currentBalance ?? 0}
    </Button>;
};